import { render, staticRenderFns } from "./SetReturnItem.vue?vue&type=template&id=ca5bfdec"
import script from "./SetReturnItem.vue?vue&type=script&lang=ts"
export * from "./SetReturnItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports